import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { LieferungStatusLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MultiSelect } from '../Select/MultiSelect';

interface LieferungStatusProps {
    disabled?: boolean;
    value: string[];
    renderLabel?: 'label' | 'placeholder';
    onChange: (newValue: string[]) => void;
}

export const LieferungStatusMulti: React.FC<LieferungStatusProps> = ({
    value,
    disabled = false,
    renderLabel = 'label',
    onChange,
}) => {
    const options = React.useMemo(() => {
        const list: SelectOption[] = [];

        Object.keys(LieferungStatusLabel).forEach((key) => {
            list.push({
                value: key,
                label: LieferungStatusLabel[key],
            });
        });

        return list;
    }, []);

    const selectedOptions = React.useMemo(() => {
        return value.map((v) => ({
            value: v,
            label: LieferungStatusLabel[v] || v,
        }));
    }, [value]);

    return (
        <>
            {renderLabel === 'label' && <Label>Status</Label>}
            <MultiSelect
                name="status"
                isDisabled={disabled}
                value={selectedOptions}
                options={options}
                onChange={(newOptions: ValueType<SelectOption, true>): void => {
                    onChange(((newOptions || []) as SelectOption[]).map((option) => option.value));
                }}
                placeholder={renderLabel === 'placeholder' ? 'Status' : ''}
            />
        </>
    );
};
